var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "header",
        [
          _c("main-header", {
            attrs: { notificacao: false, hasListagemModelo: false }
          })
        ],
        1
      ),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("informacoes-conversa", {
              attrs: { idConversa: _vm.idConversa, voltar: "ouvidoria/home" },
              on: { statusChanged: _vm.setStatus }
            })
          ],
          1
        )
      ]),
      _c(
        "el-row",
        { staticClass: "voltar-container" },
        [
          _c("app-buttons-cadastro", {
            attrs: {
              isPrimeiroPasso: false,
              isUltimoPasso: true,
              showButtonFinalizar: false,
              showButtonEnviar: false,
              showButtonCancelar: false,
              showButtonDownload: _vm.isAmapa
            },
            on: { download: _vm.download, voltar: _vm.voltar }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55e38efb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e38efb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ouvidoria/VisualizarConversa.vue
// module id = null
// module chunks = 